import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function InspectorSkeleton() {
  const { t } = useTranslation()
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 4px' }}>
      <Loader2 size={14} className="animate-spin" style={{ color: 'var(--muted-foreground)' }} />
      <span style={{ fontSize: 12, color: 'var(--muted-foreground)' }}>
        {t('documents.detail.loadingDetail')}
      </span>
    </div>
  )
}
